const Hyperlink = ({ children, ...props }) => (
  <a href={props.href} target="_blank" rel="noopener noreferrer" className="hyperlink">{children}</a>
);

export default Hyperlink;